var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['org-operate-btn', _vm.active ? 'org-operate-btn-active' : ''],style:({ background: `linear-gradient(${_vm.shadeColor.way}, ${_vm.shadeColor.colorFirst},
    ${_vm.shadeColor.colorLast})` }),on:{"click":_vm.btn.callback}},[_c('tIcon',{staticStyle:{"margin-right":"8px"},attrs:{"name":_vm.btn.icon}}),_vm._v(_vm._s(_vm.btn.title)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }